/**
 * Provides information about the current session, as well as keeping it alive
 */
define('session',['lib/event-emitter'], function(EventEmitter) {
	var lastSessionData = window.sessionInfo;
	var session = new EventEmitter();
	$.extend(session, lastSessionData);
	
	var UPDATE_INTERVAL = 10 * 60 * 1000;
	
	// keep session alive, and update session info if logged in/out
	setInterval(function() {
		$.ajax({
			url: '/account/session_info',
			dataType: "json"
		}).done(function(result) {
			session.updateSessionData(result);
		}).fail(function(xhr) {
			// do not notify user because this it not cricital
			console.log(xhr);
		});
	}, UPDATE_INTERVAL);
	
	session.updateSessionData = function(result) {
		if (JSON.stringify(result) != JSON.stringify(lastSessionData)) {
			$.extend(session, result); // copy values to session object
			if (lastSessionData.user != result.user)
				session.emit('userchange'); // login/logout
			lastSessionData = result;
			session.emit('change');
		}
	}

	return session;
});

